import { apiRequest } from '../helpers/helpers'

export const getLogDetails = async (companyId: string, clientId: string) => {
    const response = await apiRequest(`${process.env.REACT_APP_API_URL}/api/v1/log`,
        'POST',
        {
            companyId: companyId,
            clientId: clientId
        }
    )
    
    return response
}

export const getLogReport = async (companyId: string, clientId: string) => {
    const response = await apiRequest(`${process.env.REACT_APP_API_URL}/api/v1/log/details`,
        'POST',
        {
            companyId: companyId,
            clientId: clientId
        }
    )
    
    return response
}